<div #multiwell class="plmultiwell-panel">
  <mat-drawer-container class="plmulti-well-container" autosize>
    <mat-drawer #drawer class="plwell-sidenav" mode="side">
      <div class="plwell-available-selection">
        <div position="top" class="p-1 k-header k-grid-toolbar ng-star-inserted">
          <button type="button" themeColor="primary" kendoButton (click)="addSelectedRows()" [disabled]="availableWells.length === 0" class="k-button k-primary">
            Add Selected
          </button>
          <button type="button" themeColor="primary" kendoButton (click)="clearAvailableRows()" class="k-button k-primary">
            Cancel
          </button>
        </div>
        <ag-grid-angular #agSelectionGrid style="height: 450px;" class="ag-theme-balham" (gridReady)="onAvailableGridReady($event)"
          [gridOptions]="assetMappingPipelineGridOptions" (filterChanged)="onAvailableFilterChanged($event)"
          (selectionChanged)="onAvailableSelectionChanged($event)">
        </ag-grid-angular>
      </div>
    </mat-drawer>

    <div class="tbwell-sidenav-content">
      <div position="top" class="p-1 k-header k-grid-toolbar ng-star-inserted">
        <button type="button" kendoButton themeColor="primary" (click)="removeSelectedRows()" [disabled]="selectedWells.length === 0" class="k-button k-primary">
          Remove Selected
        </button>
        <button type="button" kendoButton themeColor="primary" (click)="clearSelectedRows()" class="k-button k-primary">
          Cancel
        </button>
      </div>
      <ag-grid-angular #agDataGrid style="height: 450px;" class="ag-theme-balham" (gridReady)="onSelectedGridReady($event)"
        [gridOptions]="assetMappingPipelineSelectedGridOptions" (selectionChanged)="onSelectedSelectionChanged($event)">
      </ag-grid-angular>
    </div>
  </mat-drawer-container>
</div>